function main() {
  const bySampleSoldsBy = ['sample'];
  const byPieceSoldsBy = ['piece', 'pc'];
  const byCaseSoldsByWithoutCalculator = ['default title', 'bundle', 'sheet', ...byPieceSoldsBy];
  const byCaseSoldsBy = ['case', 'sqft', 'cases', ...byCaseSoldsByWithoutCalculator];

  const product = JSON.parse(localStorage.getItem('productData'));
  const productMetafields = JSON.parse(localStorage.getItem('productMetafieldsData'));
  const variantsMetaFields = JSON.parse(localStorage.getItem('variantsMetaFieldsData'));

  const indexedVariants = new Map();

  for (const variant of product.variants) {
    indexedVariants.set(variant.id, variant);
  }

  function getVariantDataById(variantId) {
    return {
      selectedVariant: indexedVariants.get(parseInt(variantId)),
      selectedVariantMetafields: variantsMetaFields[variantId]
    }
  }

  function productSelectChange() {
    const variantId = $('#actualProdSelect').val() ?? $('input[name="id"]:checked').val() ?? $('input[name="id"]').val();
    const {selectedVariant, selectedVariantMetafields} = getVariantDataById(variantId);
    const descriptionData = getDescriptionData(selectedVariant, selectedVariantMetafields);

    updateDescriptionTable(descriptionData);

    const lowerCaseSoldBy = descriptionData?.sold_by?.toLowerCase();
    const sqftAdditionalCalc = $('#sqft_additional_calc');

    $('.sold_by_type').text(descriptionData.sold_by);

    if(byPieceSoldsBy.includes(lowerCaseSoldBy)) {
      $('#header_price_sqft').hide();
    }

    if (bySampleSoldsBy.includes(lowerCaseSoldBy)) {
      const quantity = parseInt($('#quantity').val());

      if (quantity > 5) {
        $('#quantity-minus').click();
      }

      sqftAdditionalCalc.hide();
    } else {
      if (lowerCaseSoldBy === 'sheet' || (!byCaseSoldsByWithoutCalculator.includes(lowerCaseSoldBy) && lowerCaseSoldBy !== 'sqft')) {
        sqftAdditionalCalc.show();
      } else {
        sqftAdditionalCalc.hide();
      }

      const perCaseSQFT = parseFloat(descriptionData.per_case_sqft).toFixed(2);
      $('.sq_feet_per_case').text(perCaseSQFT);

      if (descriptionData.price_per_sqft) {
        $('#header_price_sqft').show();

        const toUpdate = `$${parseFloat(descriptionData.price_per_sqft).toFixed(2)}`;

        $('#header_price_per_sqft').text(toUpdate);
      }
    }

    $('.product-type').text(descriptionData.sold_by);

    calculateSqFt();
    calculate_price();
    $('#sqft_error_msg').hide();

    /*const gallery = $('#variant_images');

    gallery.children().remove();

    if (descriptionData.variant_pictures.length > 0) {
      $('#lifestyle_images_text').show();
      $('#lifestyle_images_color').text(descriptionData.color);
    } else {
      $('#lifestyle_images_text').hide();
    }

    for (const image of descriptionData.variant_pictures) {
      gallery.append(`<div class="gallery"><a target="_blank" href="${image}"><img src="${image}" width="600" height="400"></a></div>`);
    }*/
  }

  function calculate_price() {
    const variantId = $('#actualProdSelect').val() ?? $('input[name="id"]:checked').val() ?? $('input[name="id"]').val();
    const {selectedVariant, selectedVariantMetafields} = getVariantDataById(variantId);
    const descriptionData = getDescriptionData(selectedVariant, selectedVariantMetafields);
    const soldBy = descriptionData.sold_by?.toLowerCase();

    if (bySampleSoldsBy.includes(soldBy) || byCaseSoldsByWithoutCalculator.includes(soldBy)) {
      $('.product-calculator').find('tr').hide();
      $('.borderatable').hide();
      $('.col-4-of-8').hide();
      if (bySampleSoldsBy.includes(soldBy)) {
        $('.sample_text').show();
      } else {
        $('.sample_text').hide();
      }
    } else {
      $('.product-calculator').find('tr').show();
      $('.col-4-of-8').show();
      $('.borderatable').show();
      $('.sample_text').hide();

      if (soldBy === 'case') {
        $('#calculator_sqft_per_case').show();
        $('#calculator_how_many_cases').show();
        $('#how_many_sold_by').text('cases');
      } else {
        $('#calculator_sqft_per_case').hide();
        $('#calculator_how_many_cases').hide();
        $('#how_many_sold_by').text(soldBy);
      }
    }

    if (byCaseSoldsBy.includes(soldBy)) {
      //$('.TotalAmount').text('');
      const sf_inp = $('#sf_input').val().trim();

      if (sf_inp !== '') {
        const product_price = selectedVariant.price / 100;
//      const product_price = $('#cal_pro_price').val()/100;
        const overage_perc = $('#overage_perc').val();
        const sq_feet_per_case = descriptionData.per_case_sqft;
        const overage = (sf_inp * overage_perc) / 100;
        const sqft = +overage + +sf_inp;    //step1
        const tot_piece_needed = sqft / sq_feet_per_case; //step2
        const tot_piece_rounded = Math.ceil(tot_piece_needed);  //step3
        const tot_sqft = tot_piece_rounded; //step4
        const total_price = tot_piece_rounded * sq_feet_per_case * product_price; //step5

        $('.total_sq_feet').text(tot_sqft);

        //$('.TotalAmount').text($('#ProductPrice').text().split('$')[1].trim());

        $('.percentage_sheet').text(overage_perc);
        $('.no_of_sheets').text(sqft);

        if (total_price.toFixed(2) > 0) {
          //   	 $('button#AddToCartDesk').removeAttr('disabled','disabled');
          $('#sqft_error_msg').hide();

        } else {

          //   	 $('button#AddToCartDesk').attr('disabled','disabled');
          $('#sqft_error_msg').show();
        }

      } else {
        $('#sqft_error_msg').show();
        //  $('button#AddToCartDesk').attr('disabled','disabled');
        //$('.TotalAmount').text('--.--');
        $('.percentage_sheet').text(0);
        $('.no_of_sheets').text(0);
      }

      /*if (sold_by === 'Piece') {
        var product_price = $('#ProductPrice').text().substring(1).trim();
        $('.TotalAmount').text(product_price);
      }*/
    }

  }

//    Formulas
//       (Sq.Ft Needed x Overage) + Sq.Ft Needed = Sq.Ft
//       (Sq.Ft x Sq.Ft. Per Piece) and then ROUND UP to the nearest ONE = Total Sq.Ft
//       Price Per SF x Total SF = Total Price of Order
//       localStorage.setItem('NewPrice',total_price);


//updated formulas
//       step1: (Sq.Ft Needed x Overage) + Sq.Ft. Needed = Sq.Ft.
//      step 2: Sq.Ft. / SqFt. Per Piece = Total Prices Needed
//       step3 : RoundUp (Total Pieces Needed) = Total PIECES Needed Round Up
//      step4:  Total Pieces Needed Rounded Up x Sq.Ft. Per Piece = Total SqFt.
// 	step5: Total Pieces Needed Rounded Up x Sq.Ft. Per Piece x Price Per Sq.Ft. = Total Price

  function calculateSqFt() {
    const quantity = parseInt($('#quantity').val());
    const variantId = $('#actualProdSelect').val() ?? $('input[name="id"]:checked').val() ?? $('input[name="id"]').val();
    const {selectedVariant, selectedVariantMetafields} = getVariantDataById(variantId);
    const descriptionData = getDescriptionData(selectedVariant, selectedVariantMetafields);
    const soldBy = descriptionData.sold_by?.toLowerCase();
    let total_sq_ft = 0;

    if (bySampleSoldsBy.includes(soldBy)) {
      const pieceSqft = parseFloat(descriptionData.piece_sqft);
      const calcNumOfPieces = quantity * pieceSqft;

      total_sq_ft = calcNumOfPieces.toFixed(2);
    } else if (byCaseSoldsBy.includes(soldBy)) {
      switch (soldBy) {
        case 'case':
        case 'cases':
          const sqFtPerCase = descriptionData.per_case_sqft;
          const calcNumOfCases = quantity * sqFtPerCase;

          total_sq_ft = calcNumOfCases.toFixed(2);
          break;
        case 'sheet':
          const pieceSqft = parseFloat(descriptionData.piece_sqft);
          const calcNumOfPieces = quantity * pieceSqft;

          total_sq_ft = calcNumOfPieces.toFixed(2);
          break;
      }
    }

    $('.total_sq_ft').text(total_sq_ft);
  }

  function updateQuantityField() {
    const variantId = $('#actualProdSelect').val() ?? $('input[name="id"]:checked').val() ?? $('input[name="id"]').val();
    const {selectedVariant, selectedVariantMetafields} = getVariantDataById(variantId);
    const descriptionData = getDescriptionData(selectedVariant, selectedVariantMetafields);
    const soldBy = descriptionData.sold_by?.toLowerCase();
    let quantity = 0;

    switch (soldBy) {
      case 'case':
      case 'cases':
        quantity = parseInt($('.total_sq_feet').text());
        break;
      case 'sqft':
        quantity = Math.ceil(parseFloat($('.no_of_sheets').text()));
        break;
    }

    $('#quantity').val(quantity - 1);
    $('#quantity-plus').click();
  }

  function getDescriptionData(variant, variantMetafields) {
    const pieceSqft = productMetafields?.piece_sqft;
    const casePack = productMetafields?.case_pack;

    const per_case_sqft = parseFloat(productMetafields?.sqft_per_case);

    /*let variant_pictures;

    try {
      variant_pictures = JSON.parse(variantMetafields?.variant_pictures);
    } catch (e) {
      variant_pictures = [];
    }*/

    const lowerCaseSoldBy = variant?.option1?.toLowerCase();
    const weightInLbs = variant.weight / 453.59237;
    let weightPerPiece;
    let weightPerCase;

    if(lowerCaseSoldBy === 'case' || lowerCaseSoldBy === 'cases') {
      weightPerCase = weightInLbs;
    } else {
      weightPerPiece = weightInLbs;
    }

    return {
      thickness: productMetafields?.thickness_depth,
      uses: null,
      size: productMetafields?.size,
      piece_sqft: pieceSqft,
      piece_weight_lbs: weightPerPiece,
      case_pack: casePack,
      per_case_sqft,
      case_weight_lbs: weightPerCase,
      sold_by: variant?.option1,
      price: variant?.price / 100,
      product_format: variantMetafields?.product_format,
      price_per_sqft: !byPieceSoldsBy.includes(lowerCaseSoldBy) && productMetafields?.price_per_sqft
      // variant_pictures,
    };
  }

  function updateDescriptionTable(dataObject) {
    for (const [key, value] of Object.entries(dataObject)) {
      const trId = `#${key}`;

      if (value) {
        $(trId).show();

        const valueToProcess = parseFloat(value);
        let valueToUpdate;

        if (!Number.isInteger(valueToProcess) && Number.isFinite(valueToProcess)) {
          const fixedValue = valueToProcess.toFixed(key === 'thickness' ? 3 : 2);
          valueToUpdate = key.includes('price') ? `$${fixedValue}` : fixedValue;
        } else {
          valueToUpdate = value;
        }

        $(`${trId} .tg-ycr8`).text(valueToUpdate);
      } else {
        $(`${trId} .tg-ycr8`).parent().hide();
      }
    }
  }

  function onSomeSelectChange() {
    $('#actualProdSelect').change();
    updateQuantityField();
  }

  $(document).ready(function () {
    $('#overage_perc').val(10);
    $('.total_sq_feet').text(0);

    productSelectChange();

    $('#overage_selector').change(function () {
      const overagePercElement = $('#overage_perc');

      if ($(this).prop('checked')) {
        overagePercElement.val(0);
        overagePercElement.prop('disabled', true);
      } else {
        overagePercElement.val(10);
        overagePercElement.prop('disabled', false);
      }

      overagePercElement.trigger('change');
    });

    $('#sf_input').blur(function () {
      calculate_price();
    });

    $('#overage_perc').change(function () {
      calculate_price();
      updateQuantityField();
    });

    $('#quantity-plus,#quantity-minus').click(function () {
      const variantId = $('#actualProdSelect').val() ?? $('input[name="id"]:checked').val() ?? $('input[name="id"]').val();
      const {selectedVariant, selectedVariantMetafields} = getVariantDataById(variantId);
      const descriptionData = getDescriptionData(selectedVariant, selectedVariantMetafields);
      const quantity = parseInt($('#quantity').val());

      if (bySampleSoldsBy.includes(descriptionData?.sold_by?.toLowerCase()) && quantity > 5) {
        $('#quantity-minus').click();
      } else {
        calculate_price();
        calculateSqFt();
      }
    });

    $('#productSelect').change(onSomeSelectChange);

    for (let i = 0; i < 3; i++) {
      $(`#productSelect-op${i}`).change(onSomeSelectChange);
    }

    $('#actualProdSelect').change(productSelectChange);
    $('input[name="id"]').change(productSelectChange);

    $('#sf_input').on('keyup', function () {

      var digits = /[0-9]/g;
      var num = $(this).val();
      var check_digit = num.match(digits);
      if (!check_digit || num.includes('.')) {
        $(this).val('');
        $('#sf_input').trigger('blur');
      } else {
        calculate_price();
      }

      updateQuantityField();
    });
  });
}

main();
